export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["new"] = "new";
    NotificationStatus["sent"] = "sent";
    NotificationStatus["error"] = "error";
    NotificationStatus["isNotified"] = "isNotified";
    NotificationStatus["isRead"] = "isRead";
})(NotificationStatus || (NotificationStatus = {}));
